import { gql } from '@zenbusiness/application-commons-graphql';

export const GET_PENDING_SECTION = gql`
  query PendingSection($params: PendingSectionInput!) {
    pendingSection(params: $params) {
      items {
        __typename
        ... on CheckDeposit {
          id
          type
          reason
          method
          depositTo
          summary
          amount {
            amount
            currency
            formattedAmount
          }
          createdAt
          estimatedCompletionDate
          transactionId
          checkDepositStatus: status
        }
        ... on Payment {
          id
          type
          paymentStatus: status
          paymentDirection: direction
          summary
          toAccount
          createdAt
          fromAccount
          amount {
            amount
            currency
            formattedAmount
          }
          transactionId
          estimatedCompletionDate
          description
          counterpartyId
          # new attributes
          sameDay
          # to account fields
          to {
            accountHolder
            accountNumber
            fullAccountNumber
            routingNumber
          }
          # from account fields
          from {
            accountHolder
            accountNumber
            fullAccountNumber
            routingNumber
          }
        }
        ... on Authorization {
          id
          type
          summary
          amount {
            amount
            currency
            formattedAmount
          }
          merchant
          recurring
          createdAt
          paymentMethod
          authorizationStatus: status
          authorizationDirection: direction
          # new attributes
          cardId
          digitalWallet
          ecommerce
          verificationMethod
          merchantName
          merchantLocation
          merchantCategory
          currencyConversion {
            originalCurrency
            amountInOriginalCurrency
            fxRate
          }
          declineReason
          cardLast4Digits
        }
      }
      pagination {
        total
        offset
        limit
        next
      }
    }
  }
`;
